import service from '@api/config'

// 获取banner
export const trainBanner = (data) => {
  return service.request({
    url: `/train/banner`,
    method: 'post',
    data: data
  })
}

// 获取分类区
export const trainArea = (data) => {
  return service.request({
    url: `/train/area`,
    method: 'post',
    data: data
  })
}

// 获取课程列表
export const trainCourse = (data) => {
  return service.request({
    url: `/train/course`,
    method: 'post',
    data: data
  })
}

// 获取观看记录课程列表
export const trainCourseHist = (data) => {
  return service.request({
    url: `/train/course/play/record`,
    method: 'post',
    data: data
  })
}

// 获取课程详情
export const courseDetail = (data) => {
  return service.request({
    url: `/train/courseDetail`,
    method: 'post',
    data: data
  })
}

// 新增课程
export const courseAdd = (data) => {
  return service.request({
    url: `/train/courseAdd`,
    method: 'post',
    data: data
  })
}

// 视频学习结束,获取下一视频
export const videoEnd = (data) => {
  return service.request({
    url: `/train/videoEnd`,
    method: 'post',
    data: data
  })
}

// 获取类型列表
export const typeList = (data) => {
  return service.request({
    url: `/train/typeList`,
    method: 'post',
    data: data
  })
}

// 获取推荐列表
export const excellent = (data) => {
  return service.request({
    url: `/pc/course/excellent`,
    method: 'post',
    data: data
  })
}
